import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index";
import { tracking_router } from "@/router/tracking";

Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: { name: "home" } },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/Home.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/AboutUs.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import("@/views/FAQ.vue"),
    meta: { requiresAuth: true }
  },

  {
    path: "/service-area/:serviceAreaId",
    name: "service-area",
    component: () => import("@/views/ServiceAreaDetail"),
    meta: { requiresAuth: true }
  },
  {
    path: "/service-area/:serviceAreaId/service/:serviceId",
    name: "service",
    component: () => import("@/views/ServiceDetail"),
    meta: { requiresAuth: true }
  },
  {
    path:
      "/service-area/:serviceAreaId/service/:serviceId/sub-service/:subServiceId",
    name: "sub-service",
    component: () => import("@/views/SubServiceDetail"),
    meta: { requiresAuth: true }
  },

  {
    path: "/constructions-map",
    name: "constructions-map",
    component: () => import("@/views/ConstructionsMap.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/news",
    name: "news",
    component: () => import("@/views/News.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/news-detail/:newsId/",
    name: "newsDetail",
    component: () => import("@/views/NewsDetail.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/press-detail/:pressId/",
    name: "pressDetail",
    component: () => import("@/views/PressDetail.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/newcompany-detail/:newCompanyId/",
    name: "newCompanyDetail",
    component: () => import("@/views/NewCompanyDetail.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/approval",
    name: "approval-pending",
    component: () => import("@/views/ApprovalPending.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login.vue")
  },
  {
    path: "/connect/login_new_ag/redirect",
    name: "oauth-redirect",
    component: () => import("@/views/SsoRedirect.vue")
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/Search"),
    meta: { requiresAuth: true }
  },
  {
    path: "/bildungsportal/search",
    name: "bildungsportal-search",
    component: () => import("@/views/BildungsportalSearch"),
    meta: { requiresAuth: true }
  },
  {
    path: "/magazin",
    name: "magazin",
    component: () => import("@/views/Magazin"),
    meta: { requiresAuth: true }
  },
  {
    path: "/funds",
    name: "funds",
    component: () => import("@/views/Funds"),
    meta: { requiresAuth: true }
  },
  {
    path: "/funds/:id",
    name: "fund-details",
    component: () => import("@/views/FundDetails"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/vertragsuebersicht",
    name: "vertragsuebersicht",
    component: () => import("@/views/ContractOverview.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/konzessionsthemen",
    name: "konzessionsthemen",
    component: () => import("@/views/Konzessionsthemen.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/verbrauchsdaten",
    name: "verbrauchsdaten",
    component: () => import("@/views/Verbrauchsdaten.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/waermeplanung",
    name: "waermeplanung",
    component: () => import("@/views/Waermeplanung.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/waermeplanung-faq",
    name: "waermeplanung-faq",
    component: () => import("@/views/WaermeFAQ.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/new-erleben",
    name: "new-erleben",
    component: () => import("@/views/MomentsView.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/commune-dashboard",
    name: "commune-dashboard",
    component: () => import("@/views/CommuneDashboard.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/notification-config",
    name: "notification-config",
    component: () => import("@/views/NotificationConfig.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/konzessionsabgaben",
    name: "konzessionsabgaben",
    component: () => import("@/views/Konzessionsabgaben.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/bildungsmaterial-list/:id",
    name: "bildungsmaterial",
    component: () => import("@/views/BildungsMaterialList.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/bildungsmaterial/:id",
    name: "bildungsmaterial-details",
    component: () => import("@/views/BildungsMaterialDetails.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/bildungsportal/contact",
    name: "bildungsportal-contact",
    component: () => import("@/views/BildungsportalContactView.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/sponsoring",
    name: "sponsoring",
    component: () => import("@/views/BildungsportalSponsoring.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/veranstaltungen",
    name: "veranstaltungen",
    component: () => import("@/views/VeranstaltungenList.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/veranstaltungen/:id",
    name: "veranstaltungen-details",
    component: () => import("@/views/VeranstaltungDetails.vue"),
    props: route => ({ id: parseInt(route.params.id) }),
    meta: { requiresAuth: true }
  },
  {
    path: "/analytics",
    name: "analytics",
    component: () => import("@/views/AnalyticsView.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/elections",
    name: "elections",
    component: () => import("@/views/Elections.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/elections/:electionId/candidates/:candidateId",
    name: "candidate-details",
    component: () => import("@/views/Candidate.vue"),
    props: route => ({
      electionId: parseInt(route.params.electionId),
      candidateId: parseInt(route.params.candidateId)
    }),
    meta: { requiresAuth: true }
  },
  {
    path: "/waerme-analytics",
    name: "waerme-analytics",
    component: () => import("@/views/WaermeAnalytics.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/social-media-campaign/:id",
    name: "social-media-campaign",
    component: () => import("@/views/SocialMediaCampaign.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/strom",
    name: "strom",
    component: () => import("@/views/StromView.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/gas",
    name: "gas",
    component: () => import("@/views/GasView.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/trinkwasser",
    name: "trinkwasser",
    component: () => import("@/views/TrinkwasserView.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/beleuchtung",
    name: "beleuchtung",
    component: () => import("@/views/BeleuchtungView.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/waerme",
    name: "waerme",
    component: () => import("@/views/Waerme.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/bahn1",
    name: "bahn1",
    component: () => import("@/views/Bahn1View.vue"),
    meta: { requiresAuth: true }
  }
];

if (process.env.NODE_ENV !== "production") {
  routes.push({
    path: "/kommunalrabatt",
    name: "kommunalrabatt",
    component: () => import("@/views/Kommunalrabatt"),
    meta: { requiresAuth: true }
  });
  routes.push({
    path: "/lieferstellen",
    name: "lieferstellen",
    component: () => import("@/views/Lieferstellen"),
    meta: { requiresAuth: true }
  });
}

routes.push({
  path: "/:match(.*)*",
  name: "not-found",
  component: () => import("@/views/NotFound"),
  meta: { requiresAuth: true }
});

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

/**
 * @param {Route} toRoute
 * @param {Function} nextFn
 * @private
 */
function _handleLoggedInUser(toRoute, nextFn) {
  const approveRoute = "approval-pending";
  const isUserApproved = store.getters["user/isUserApproved"];
  const isOnApproveRoute = toRoute.name === approveRoute;

  const redirectUrl = window.sessionStorage.getItem("REDIRECT_URL");
  const showBildungsportal = store.getters["user/showBildungsportal"];

  if (showBildungsportal && toRoute.name === "search") {
    nextFn({
      name: "bildungsportal-search",
      query: toRoute.query
    });
    return;
  }

  if (!showBildungsportal && toRoute.name === "bildungsportal-search") {
    nextFn({
      name: "search",
      query: toRoute.query
    });
    return;
  }

  if (!isUserApproved && !isOnApproveRoute) {
    nextFn({ name: approveRoute });
    return;
  } else if (isOnApproveRoute && isUserApproved && !redirectUrl) {
    // when is approved, but on approval pending page
    nextFn({ name: "home" });
    return;
  } else if (redirectUrl) {
    window.sessionStorage.removeItem("REDIRECT_URL");
    nextFn(redirectUrl);
    return;
  }

  nextFn();
}

router.beforeEach((to, from, next) => {
  // google analytics tracking
  tracking_router(to, from);

  // if route requires auth, check if logged in
  if (to.matched.some(route => route.meta.requiresAuth)) {
    const isInitialPageLoad = !from.name;
    if (isInitialPageLoad) {
      store.dispatch("user/verifyAuth").then(() => {
        // if not, redirect to login page.
        if (!store.getters["user/isLoggedIn"]) {
          console.dir(to);
          window.sessionStorage.setItem("REDIRECT_URL", to.fullPath);
          next({
            name: "login"
            // query: { redirect: to.fullPath }
          });
        } else {
          // check if users account is confirmed (via strapi backend)
          _handleLoggedInUser(to, next);
        }
      });
    } else {
      // assume verified auth when user is coming from other Vue route
      _handleLoggedInUser(to, next);
    }
  } else {
    if (to.name == "login") {
      // if user is on login page and has valid session, redirect him
      store.dispatch("user/verifyAuth").then(() => {
        if (store.getters["user/isLoggedIn"]) {
          router.replace({ name: "home" });
        }
      });
    }

    next(); // make sure to always call next()!
  }
});

export default router;
